import type {
  Graph3DBounds,
  Graph3DPositionedNode,
  Graph3DVector3,
} from '../core/graph.types';

const zero: Graph3DVector3 = { x: 0, y: 0, z: 0 };

export function calculateBounds<TNodeData = unknown>(
  nodes: Graph3DPositionedNode<TNodeData>[]
): Graph3DBounds {
  if (nodes.length === 0) {
    return { min: zero, max: zero, center: zero, size: zero };
  }

  const min = { x: Infinity, y: Infinity, z: Infinity };
  const max = { x: -Infinity, y: -Infinity, z: -Infinity };

  nodes.forEach(node => {
    const halfWidth = node.resolvedSize.width / 2;
    const halfHeight = node.resolvedSize.height / 2;
    const halfDepth = node.resolvedSize.depth / 2;
    min.x = Math.min(min.x, node.resolvedPosition.x - halfWidth);
    min.y = Math.min(min.y, node.resolvedPosition.y - halfHeight);
    min.z = Math.min(min.z, node.resolvedPosition.z - halfDepth);
    max.x = Math.max(max.x, node.resolvedPosition.x + halfWidth);
    max.y = Math.max(max.y, node.resolvedPosition.y + halfHeight);
    max.z = Math.max(max.z, node.resolvedPosition.z + halfDepth);
  });

  const size = { x: max.x - min.x, y: max.y - min.y, z: max.z - min.z };
  const center = {
    x: min.x + size.x / 2,
    y: min.y + size.y / 2,
    z: min.z + size.z / 2,
  };
  return { min, max, center, size };
}
